import React from 'react';
import PropTypes from 'prop-types';

const CheerPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M14.017 5.108c1.258 1.548 9.414 11.613 14.086 17.9.405-.081.772-.028 1.048.185.756.581.544 2.121-.473 3.445-1.018 1.32-2.45 1.923-3.207 1.342-.256-.197-.401-.504-.442-.875a112.67 112.67 0 0 1-4.79-1.854 2.367 2.367 0 0 1-3.242 2.08L11.42 25.09a2.362 2.362 0 0 1-1.306-3.08c.144-.36.374-.653.644-.892a401.323 401.323 0 0 1-6.362-2.969 2.9 2.9 0 0 1-1.096-.516c-2.076-1.595-1.522-5.796 1.234-9.385 2.756-3.585 6.815-5.364 8.89-3.77.232.178.429.39.592.63zM7.468 17.753l5.84 2.707s5.787 2.63 5.93 2.733c3.68 1.689 6.738 3.067 7.075 3.157.662-.198 1.351-1.837 1.351-1.837L14.574 8.348c-.228 1.776-1.1 3.832-2.523 5.68-1.364 1.776-3.013 3.067-4.583 3.725zm11.09 7.422c.032-.086.073-.307.095-.577a280.065 280.065 0 0 1-6.48-2.832 6.6 6.6 0 0 0-.387.689c-.266.662.211 1.013.873 1.279l4.382 1.76c.662.266 1.252.343 1.518-.32z"
    />
  );
};

CheerPath.propTypes = {
  fill: PropTypes.string,
};

export default CheerPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/cheer.jsx